// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__3sjys","emailz":"NavBar_emailz__2DP8k","socialIconList":"NavBar_socialIconList__3rxw1"};